import React from 'react';

import VerificationContent from './VerificationContent';
import {
  sendVerification,
  togglePhoneVerifyModal,
} from '../../../../actions/dashboard';
import styles from '../../../../styles/sass/components/Dashboard.module.scss';

interface Props {
  dispatch: Function;
  phoneNumber: string | number | undefined;
  phoneNumberVerified: boolean;
  phoneVerificationSent: boolean;
  token: string;
}

function PhoneVerification(props: Props) {
  const {
    dispatch,
    phoneNumber,
    phoneNumberVerified,
    phoneVerificationSent,
    token,
  } = props;

  if (phoneNumberVerified) {
    return (
      <div
        className={styles.verifyContainer}
        style={{
          background: 'rgba(135, 200, 100, 0.2)',
          border: '1px solid #195a50',
        }}
      >
        <VerificationContent
          icon="success"
          title="Your phone number has been verified!"
        />
      </div>
    );
  } else if (!phoneNumber) {
    return (
      <div className={styles.verifyContainer}>
        <VerificationContent
          icon="warning"
          title="Add and verify your phone number"
          info="Bring extra security by adding your phone number to your account"
          buttonText="Add phone number"
          onClick={() => dispatch(togglePhoneVerifyModal(true))}
        />
      </div>
    );
  } else if (!phoneNumberVerified && !phoneVerificationSent) {
    return (
      <div className={styles.verifyContainer}>
        <VerificationContent
          icon="warning"
          title="Verify your phone number"
          info="Bring extra security by verifying your phone number"
          buttonText="Send verification"
          onClick={() => {
            dispatch(sendVerification('phone', token));
          }}
        />
      </div>
    );
  } else if (!phoneNumberVerified && phoneVerificationSent) {
    return (
      <div className={styles.verifyContainer}>
        <VerificationContent
          icon="paperPlane"
          title="Please check your phone to finish verifying"
          buttonText="Enter verification code"
          onClick={() => dispatch(togglePhoneVerifyModal(true))}
        />
      </div>
    );
  }
  return null;
}

export default PhoneVerification;
